import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "../../context/ThemeContext";
import defaultBot from "../../assets/common/resources/Sikibot.png";
import "./index.scss";

function Loader({ _class, wait, message }) {
  const themeContext = useTheme();
  const currentTheme = themeContext?.currentTheme;
  const getLoadingConfig = themeContext?.getLoadingConfig;
  const loadingConfig =
    typeof getLoadingConfig === "function" ? getLoadingConfig() : {};

  const resolvedIcon = loadingConfig.icon || defaultBot;
  const resolvedAlt = loadingConfig.alt || "Loading";
  const resolvedMessage =
    message ?? loadingConfig.message ?? "Please wait...";

  const palette = currentTheme?.palette || {};
  const paperColor =
    palette.background?.paper || "var(--paper-color, rgba(23, 21, 21, 0.85))";
  const textPrimary =
    palette.text?.primary || "var(--text-primary, rgba(255, 255, 255, 0.92))";
  const borderColor =
    palette.mode === "light"
      ? "rgba(0, 0, 0, 0.08)"
      : "rgba(255, 255, 255, 0.12)";

  return (
    <Box className={_class ? _class : "__loader"}>
      {wait ? (
        <Stack
          direction="column"
          alignItems="center"
          spacing={2}
          sx={{
            padding: "20px",
            borderRadius: "12px",
            background: paperColor,
            border: `1px solid ${borderColor}`,
            boxShadow:
              palette.mode === "light"
                ? "0 12px 32px rgba(0, 0, 0, 0.12)"
                : "0 12px 32px rgba(0, 0, 0, 0.45)",
          }}
        >
          <div className="siki-loader">
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
            <div className="loader-ring"></div>
            <img
              src={resolvedIcon}
              alt={resolvedAlt}
              className="loader-logo"
            />
          </div>
          <Typography className="fs-17 fw-b" sx={{ color: textPrimary }}>
            {resolvedMessage}
          </Typography>
        </Stack>
      ) : (
        <div className="siki-loader">
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <div className="loader-ring"></div>
          <img
            src={resolvedIcon}
            alt={resolvedAlt}
            className="loader-logo"
          />
        </div>
      )}
    </Box>
  );
}

export default Loader;
